import {
  IActivityHistoryItem,
  IActivityHistoryItemCollection,
  IHistoryDataImporterRules,
  TSearchActivityHistoryItemPredicate,
} from "../../domain/model";

export const addItemsToCollection = (
  collections: Record<string, IActivityHistoryItemCollection>,
  id: string,
  items: IActivityHistoryItem[],
  componentFactory?: (item: IActivityHistoryItem) => HTMLElement,
  searchPredicate?: TSearchActivityHistoryItemPredicate,
  historyDataImporterRules?: IHistoryDataImporterRules,
) => {
  // Crea la colección si no existe
  if (!collections[id]) {
    return { ...collections, [id]: { id, items, componentFactory, searchPredicate, historyDataImporterRules } };
  }
  // Si la colección ya existe, fusiona el array existente con el nuevo; si arriba
  // un nou set de regles, prevaleix; si no, manté les que ja tenia.
  return {
    ...collections,
    [id]: {
      ...collections[id],
      items: [...(collections[id]?.items || []), ...items],
      historyDataImporterRules: historyDataImporterRules ?? collections[id]?.historyDataImporterRules,
    },
  };
};
